
export const setStorage = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data))
}

export const getStorage = (key) => {
    let value = localStorage.getItem(key)
    return value ? JSON.parse(value) : null
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
    return null
}

export const clearStorage = (callBack) => {
    localStorage.clear()
    if (callBack) {
        callBack()
    } else {
        window.location.href = "/login"
    }
}